import { AppBar, Box, Button, Toolbar, Typography } from "@mui/material";
import { Link, Outlet } from "react-router-dom";
import { getAuthenticationManager } from "../utils/Authentication";

export default function PageContainer() {
    const handleLogout = () => {
        const auth = getAuthenticationManager();
        auth.logout().then();
    };

    return (
        <Box sx={{ mt: 10, mb: 2 }}>
            <AppBar position="fixed">
                <Toolbar>
                    <Typography
                        variant="h6"
                        sx={{ mr: 2 }}
                        color={"text.primary"}
                    >
                        مدیریت کاربران
                    </Typography>

                    <Link to="/">
                        <Button>کاربران</Button>
                    </Link>

                    <Box flexGrow={1} />

                    <Button onClick={handleLogout}>خروج</Button>
                </Toolbar>
            </AppBar>
            <Outlet />
        </Box>
    );
}
